module.exports = __webpack_public_path__ + "static/media/Technologyicon04@3x.5a281360.png";